// This function converts bytes into a more readable format (KB, MB, GB).
export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return '0 Bytes'; // Use !+bytes to handle 0, null, undefined

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};